import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api/bff-prompts';

@Injectable({
  providedIn: 'root',
})
export class AvaliacoesPromptService {
  private endpoint = 'prompt/avaliacao';

  constructor(private apiService: ApiService) {}

  getAvaliacoesPorPrompt(idPrompt: number): Observable<any> {
    return this.apiService.get<any>(`${this.endpoint}?id=${idPrompt}`);
  }

  adicionarAvaliacao(
    idPrompt: number,
    idUsuario: number,
    nota: number,
    comentario: string
  ): Observable<any> {
    const body = {
      idPrompt,
      idUsuario,
      data: new Date().toISOString(),
      nota,
      comentario,
    };
    return this.apiService.post<any>(this.endpoint, body);
  }
}
